import React, { useState } from 'react';

const SERVICES = [
    { title: 'فرمولاسیون', desc: 'ما در این مجموعه فرمولاسیون‌هایی را ارائه می‌دهیم که به شما کمک می‌کنند تا به کیفیت محصولات تولیدی خود افزوده و بهترین نسخه از محصولات خود را عرضه کنید.' },
    { title: 'مشاوره تولید و ماده اولیه', desc: 'ما به عنوان یک تیم متخصص، آماده‌ایم تا به شما کمک کنیم در فرآیند تولید خود به بهترین شکل ممکن پیش بروید و مواد اولیه و مجوزهای مورد نیاز را تهیه کنیم.' },
    { title: 'رگلاتوری', desc: 'رگولاتورهای مجموعه ما به شما کمک می‌کنند تا در زمینه بسته‌بندی، اظهارنامه‌ها، فعالیت‌های ایمنی و کسب مجوزها به شکل بهینه فعالیت کنید.' },
    { title: 'مسئول فنی', desc: 'ما آمادگی معرفی مسئول فنی خبره در زمینه ارتباط با مراجع نظارتی، ارتقاء کیفیت محصولات و اطمینان از مطابقت با استانداردها را داریم.' },
    { title: 'ترخیص', desc: 'این مجموعه آمادگی دارد تا به کمک نیروهای کارآمد، محصولات آرایشی و بهداشتی شما را به طور مطمئن و مطابق با مقررات ترخیص کند.' },
    { title: 'بازرسی', desc: 'ما می‌توانیم شرکت‌های بازرسی معتبر را معرفی کنیم و به شما کمک کنیم گواهی‌های بین‌المللی کیفیت کارخانه را دریافت کنید.' },
    { title: 'تولید قراردادی', desc: 'مجموعه ما توانایی معرفی شرکت‌های تولیدکننده به صاحبان برند و بالعکس را دارد و در بهترین توافقات تولید و عرضه یاری می‌رساند.' },
    { title: 'آزمایشگاه همکار', desc: 'ما سابقه همکاری طولانی با آزمایشگاه‌های همکار داریم و خدمات بررسی کیفیت، ایمنی و مطابقت با استانداردها را به صورت تخصصی انجام می‌دهیم.' },
];

const ServiceWidget = () => {
    const [open, setOpen] = useState(null);

    const toggle = i => setOpen(open === i ? null : i);

    return (
        <>
            {SERVICES.map((s, i) => (
                <div key={i} className={`edu-acc${open === i ? ' edu-acc--open' : ''}`}>
                    <div className="edu-acc__head" onClick={() => toggle(i)}>
                        <span className="edu-acc__label">{s.title}</span>
                        <span className="edu-acc__icon">+</span>
                    </div>
                    <div className="edu-acc__body">
                        <p className="edu-acc__text">{s.desc}</p>
                    </div>
                </div>
            ))}
        </>
    );
};

export default ServiceWidget;
